module.exports = __webpack_public_path__ + "img/update_documents.3d59e2f9.svg";